export default "__VITE_ASSET__6d62ea83__"